import { ImpregnationMethodService } from 'services/impregnation-method-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ImpregnationTypeService } from 'services/impregnation-type-service';

@autoinject
export class ImpregnationMethodList {
  private tableData: Array<Models.ImpregnationMethod>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private impregnationMethodService: ImpregnationMethodService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('impregnationMethodListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.impregnationMethodService
      .getAll('?$orderby=Name')
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('impregnation-method-detail', { Id: id });
  }
}
